var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSorterDesc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7056_5104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.00101 6.25047H8.99881C9.88709 6.25047 10.3353 5.12781 9.7059 4.47225L5.7071 0.305579C5.3166 -0.101192 4.68341 -0.101225 4.29288 0.305579L0.293883 4.47225C-0.33421 5.12651 0.110946 6.25047 1.00101 6.25047ZM5 1.04213L9 5.2088H1.00001L5 1.04213Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99886 11.75H1.00116C0.112894 11.75 -0.335287 11.8278 0.294079 13.4571L4.29283 17.4571C4.68333 17.8476 5.31651 17.8476 5.70703 17.4571L9.70598 13.4571C10.3341 12.829 9.88891 11.75 8.99886 11.75ZM4.99992 16.75L0.999975 16.75H8.99986L4.99992 16.75Z",
    fill: "black",
    color: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7056_5104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 6.25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorterDesc);
export default __webpack_public_path__ + "static/media/sorter-desc.d1c3dabae5a5023087df72767a6bba4f.svg";
export { ForwardRef as ReactComponent };